import { render, staticRenderFns } from "./ImgPicker.vue?vue&type=template&id=284ca6ac&scoped=true"
import script from "./ImgPicker.vue?vue&type=script&lang=js"
export * from "./ImgPicker.vue?vue&type=script&lang=js"
import style0 from "./ImgPicker.vue?vue&type=style&index=0&id=284ca6ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284ca6ac",
  null
  
)

export default component.exports